import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" 
         style={{
           background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
           fontFamily: "'Courier New', monospace",
           color: '#BBAFF9'
         }}>
      
      <style>{`
        .storefront {
          font-size: 14px;
          line-height: 1.2;
          white-space: pre;
          text-align: center;
          margin-bottom: 20px;
          text-shadow: 0 0 10px rgba(187, 175, 249, 0.3);
        }
        
        .window-glow {
          animation: window-glow 2s ease-in-out infinite alternate;
        }
        
        @keyframes window-glow {
          0% { text-shadow: 0 0 5px rgba(187, 175, 249, 0.5); }
          100% { text-shadow: 0 0 15px rgba(187, 175, 249, 0.8), 0 0 25px rgba(187, 175, 249, 0.4); }
        }
        
        .sign {
          animation: sign-flicker 3s ease-in-out infinite;
        }
        
        @keyframes sign-flicker {
          0%, 90% { opacity: 1; }
          95% { opacity: 0.7; }
          100% { opacity: 1; }
        }
        
        .dots {
          animation: blink 1.5s infinite;
        }
        
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0.3; }
        }
      `}</style>

      <div className="storefront">
        {`┌─────────────────────────────────────┐
│                                     │
│  `}<span className="window-glow">{`╔═══╗`}</span>{`  ┌─────────────┐  `}<span className="window-glow">{`╔═══╗`}</span>{`  │
│  `}<span className="window-glow">{`║   ║`}</span>{`  │             │  `}<span className="window-glow">{`║   ║`}</span>{`  │
│  `}<span className="window-glow">{`║   ║`}</span>{`  │    `}<span className="sign">SMB.co</span>{`    │  `}<span className="window-glow">{`║   ║`}</span>{`  │
│  `}<span className="window-glow">{`║   ║`}</span>{`  │             │  `}<span className="window-glow">{`║   ║`}</span>{`  │
│  `}<span className="window-glow">{`╚═══╝`}</span>{`  └─────────────┘  `}<span className="window-glow">{`╚═══╝`}</span>{`  │
│                                     │
│     ╔══════════════════════════╗    │
│     ║  ☰ ☰ ☰ ☰ ☰ ☰ ☰ ☰ ☰ ☰  ║    │
│     ║                        ║    │
│     ║    Page Not Found      ║    │
│     ║    Error 404           ║    │
│     ║                        ║    │
│     ╚══════════════════════════╝    │
│                                     │
│    🚪  ┌───────────┐  ┌──────┐     │
│       │  CLOSED   │  │ 404  │     │
│       └───────────┘  └──────┘     │
└─────────────────────────────────────┘
  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓`}
      </div>
      
      <div className="text-center" style={{ fontSize: '16px', marginTop: '20px', opacity: 0.8 }}>
        <div>This page seems to be missing<span className="dots">...</span></div>
        <div className="mt-4">
          <Button 
            onClick={() => navigate('/')}
            className="bg-purple-600 hover:bg-purple-700 text-white"
            style={{ fontFamily: "'Courier New', monospace" }}
          >
            Return to Business Hub
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
